import { type LoadMeasures } from '../domain/LoadMeasures'
import { parseNumber } from '../utils/number'

export type RawLoadMeasures = {
  total_weight?: number
  total_volume?: number
  density?: number
  total_linear_feet?: number
}

export function mapApiToLoadMeasures(measures: RawLoadMeasures | null): LoadMeasures | undefined {
  if (!measures) {
    return undefined
  }

  return {
    totalWeight: parseNumber(measures.total_weight),
    cubicVolume: parseNumber(measures.total_volume),
    cubicDensity: parseNumber(measures.density),
    linearFeet: parseNumber(measures.total_linear_feet),
  }
}
